import APIServiceLookUp from './serviceAPI';
import { MAIN_API_URL } from './models/AppConstent';

export default class ServiceHostel {
    lookupService = new APIServiceLookUp();

    async checkInBed(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}hostel/checkInBed`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getBookingById(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}hostel/getBookingById`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async markIn(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}hostel/markIn`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async markOut(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}hostel/markOut`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async checkOutBed(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}hostel/checkOutBed`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getAllBooking(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}hostel/getAllBooking`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getAllAttendance(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}hostel/getAllAttendance`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async renewBed(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}hostel/renewBed`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }
}